import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/logo1.png';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <>
            <div className="top-bar">
                <span>&#9993; business@JeevanRealty.com</span>
                <span>&#9742; 7894561235</span>
            </div>

            <header className="navbar">
                <div className="logo">
                    <Link to="/"> <img src={logo} alt="Jeevan Realty Logo" /> </Link>
                </div>

                <nav className={isMenuOpen ? "open" : ""}>
                    <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Home</NavLink>
                    <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>About Us</NavLink>
                    <NavLink to="/whatwedo" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>What We Do</NavLink>
                    <NavLink to="/projects" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Property</NavLink>
                    <NavLink to="/blog" className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => setIsMenuOpen(false)}>Blogs</NavLink>

                    <Link to="/contact" className="mobile-contact-btn" onClick={() => setIsMenuOpen(false)}>
                        <button className="contact-btn">Contact Us</button>
                    </Link>
                </nav>

                <div className="desktop-contact-btn">
                    <Link to="/contact">
                        <button className="contact-btn">Contact Us</button>
                    </Link>
                </div>

                <div className="hamburger" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </header>
        </>
    );
};

export default Navbar;
